import React, {useState} from 'react';
import { rwbApi } from '../../../../shared/apis/api';
import CustomButton from "../CustomButton";
import EightOZIcon from '../svgs/EightOZIcon';
import SixteenOZIcon from '../svgs/SixteenOZIcon';
import ThirtyTwoOZIcon from '../svgs/ThirtyTwoOZIcon';
import TwentyFourOZIcon from '../svgs/TwentyFourOZIcon';
import TextInput from '../TextInput';
import { errorAlert } from '../../../../shared/utils/ErrorAlert';
import { generateHydrationData } from '../../../../shared/utils/ChallengeHelpers';

const MODAL_STATES = {
    default: 'default',
    custom: 'custom',
};

const predeterminedOZStyle = {
    backgroundColor: 'var(--secondary)',
    color: 'var(--white)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}

const AddHydrationModal = ({visible, onRequestClose, onSuccessfulSubmit}) => {
    const [modalState, setModalState] = useState('default');
    const [customInputValue, setCustomInputValue] = useState(null);

    const uploadHydration = (oz) => {
        const workoutData = generateHydrationData(oz);
        rwbApi.putWorkout(JSON.stringify(workoutData)).then(() => {
            if (onSuccessfulSubmit) onSuccessfulSubmit();
            onRequestClose();
        }).catch((err) => {
            console.warn('uploading hydration error: ', err);
            errorAlert(err);
        });
    }

    const defaultState = () => {
        return (
            <>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                    <CustomButton onClick={() => uploadHydration(8)} customStyles={predeterminedOZStyle} label={"8 oz"}>
                        <EightOZIcon />
                    </CustomButton>
                    <CustomButton onClick={() => uploadHydration(16)} customStyles={predeterminedOZStyle} label={"16 oz"}>
                        <SixteenOZIcon />
                    </CustomButton>
                    <CustomButton onClick={() => uploadHydration(24)} customStyles={predeterminedOZStyle} label={"24 oz"}>
                        <TwentyFourOZIcon />
                    </CustomButton>
                    <CustomButton onClick={() => uploadHydration(32)} customStyles={predeterminedOZStyle} label={"32 oz"}>
                        <ThirtyTwoOZIcon />
                    </CustomButton>
                </div>
                <CustomButton customStyles={{backgroundColor: 'var(--white)', color: 'var(--secondary)', border: '2px solid var(--secondary)'}} label={'Custom Amount'} onClick={() => setModalState(MODAL_STATES.custom)} />
                <CustomButton label={'Cancel'} onClick={onRequestClose} />
            </>
        )
    }

    const customState = () => {
        return (
            <>
                <TextInput type="number" value={customInputValue} onValueChange={(e) => setCustomInputValue(e.target.value)} label={"CUSTOM AMOUNT (IN OUNCES)"} />
                <CustomButton customStyles={{backgroundColor: customInputValue && 'var(--secondary)', color: customInputValue && 'var(--white)'}} label={'SUBMIT'} onClick={() => uploadHydration(customInputValue)} />
                <CustomButton label={'Cancel'} onClick={() => {
                    setModalState(MODAL_STATES.default);
                    setCustomInputValue('0');
                }} />
            </>
        )
    }

    return (
        modalState === MODAL_STATES.default ? defaultState() : customState()
    )
}

export default AddHydrationModal;
